export const crmMessageScheduleConditionType = {
  lastReservationCreatedAt: "Last reservation created at",
  lastReservationEndDate: "Return date",
  lastQuestionConditionCreatedAt: "Last question condition created at",
  lastMessageCreatedAt: "Last message created at",
  createdAt: "Add friend date",
  lineType: "LINE type",
};
